export default __webpack_public_path__ + "static/shopify-partner-aedac421c72ffc44a2bd182a042f1cd9.png";